[
	{
		"categoryId": "food-cafe",
		"groupId": "food",
		"nameKo": "카페",
		"slug": "food-cafe",
		"symbolId": "cup",
		"sensitive": false,
		"sortOrder": 1,
		"descKo": "카페에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-bakery",
		"groupId": "food",
		"nameKo": "베이커리",
		"slug": "food-bakery",
		"symbolId": "bread",
		"sensitive": false,
		"sortOrder": 2,
		"descKo": "베이커리에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-dessert",
		"groupId": "food",
		"nameKo": "디저트·아이스크림",
		"slug": "food-dessert",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 3,
		"descKo": "디저트·아이스크림에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-korean",
		"groupId": "food",
		"nameKo": "한식",
		"slug": "food-korean",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 4,
		"descKo": "한식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-bunsik",
		"groupId": "food",
		"nameKo": "분식",
		"slug": "food-bunsik",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 5,
		"descKo": "분식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-chinese",
		"groupId": "food",
		"nameKo": "중식",
		"slug": "food-chinese",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 6,
		"descKo": "중식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-japanese",
		"groupId": "food",
		"nameKo": "일식",
		"slug": "food-japanese",
		"symbolId": "fish",
		"sensitive": false,
		"sortOrder": 7,
		"descKo": "일식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-western",
		"groupId": "food",
		"nameKo": "양식",
		"slug": "food-western",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 8,
		"descKo": "양식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-asian",
		"groupId": "food",
		"nameKo": "아시안",
		"slug": "food-asian",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 9,
		"descKo": "아시안에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-chicken",
		"groupId": "food",
		"nameKo": "치킨",
		"slug": "food-chicken",
		"symbolId": "meat",
		"sensitive": false,
		"sortOrder": 10,
		"descKo": "치킨에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-pizza",
		"groupId": "food",
		"nameKo": "피자",
		"slug": "food-pizza",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 11,
		"descKo": "피자에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-burger",
		"groupId": "food",
		"nameKo": "버거·패스트푸드",
		"slug": "food-burger",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 12,
		"descKo": "버거·패스트푸드에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-meat",
		"groupId": "food",
		"nameKo": "고깃집",
		"slug": "food-meat",
		"symbolId": "meat",
		"sensitive": false,
		"sortOrder": 13,
		"descKo": "고깃집에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-seafood",
		"groupId": "food",
		"nameKo": "해산물",
		"slug": "food-seafood",
		"symbolId": "fish",
		"sensitive": false,
		"sortOrder": 14,
		"descKo": "해산물에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-soup",
		"groupId": "food",
		"nameKo": "국밥·탕",
		"slug": "food-soup",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 15,
		"descKo": "국밥·탕에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-noodle",
		"groupId": "food",
		"nameKo": "면요리",
		"slug": "food-noodle",
		"symbolId": "bowl",
		"sensitive": false,
		"sortOrder": 16,
		"descKo": "면요리에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-bar",
		"groupId": "food",
		"nameKo": "주점·바",
		"slug": "food-bar",
		"symbolId": "bottle",
		"sensitive": false,
		"sortOrder": 17,
		"descKo": "주점·바에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-delivery",
		"groupId": "food",
		"nameKo": "배달음식",
		"slug": "food-delivery",
		"symbolId": "bottle",
		"sensitive": false,
		"sortOrder": 18,
		"descKo": "배달음식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-grocery",
		"groupId": "food",
		"nameKo": "식료품",
		"slug": "food-grocery",
		"symbolId": "cart",
		"sensitive": false,
		"sortOrder": 19,
		"descKo": "식료품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "food-butcher",
		"groupId": "food",
		"nameKo": "정육·수산",
		"slug": "food-butcher",
		"symbolId": "meat",
		"sensitive": false,
		"sortOrder": 20,
		"descKo": "정육·수산에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-cvs",
		"groupId": "daily",
		"nameKo": "편의점",
		"slug": "daily-cvs",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 21,
		"descKo": "편의점에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-supermarket",
		"groupId": "daily",
		"nameKo": "슈퍼마켓",
		"slug": "daily-supermarket",
		"symbolId": "cart",
		"sensitive": false,
		"sortOrder": 22,
		"descKo": "슈퍼마켓에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-hypermarket",
		"groupId": "daily",
		"nameKo": "대형마트",
		"slug": "daily-hypermarket",
		"symbolId": "cart",
		"sensitive": false,
		"sortOrder": 23,
		"descKo": "대형마트에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-household",
		"groupId": "daily",
		"nameKo": "생활용품",
		"slug": "daily-household",
		"symbolId": "cart",
		"sensitive": false,
		"sortOrder": 24,
		"descKo": "생활용품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-lifestyle",
		"groupId": "daily",
		"nameKo": "라이프스타일숍",
		"slug": "daily-lifestyle",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 25,
		"descKo": "라이프스타일숍에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-stationery",
		"groupId": "daily",
		"nameKo": "문구",
		"slug": "daily-stationery",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 26,
		"descKo": "문구에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-laundry",
		"groupId": "daily",
		"nameKo": "세탁",
		"slug": "daily-laundry",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 27,
		"descKo": "세탁에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-repair",
		"groupId": "daily",
		"nameKo": "수선·수리",
		"slug": "daily-repair",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 28,
		"descKo": "수선·수리에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-print",
		"groupId": "daily",
		"nameKo": "인쇄·복사",
		"slug": "daily-print",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 29,
		"descKo": "인쇄·복사에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-unmanned",
		"groupId": "daily",
		"nameKo": "무인점포",
		"slug": "daily-unmanned",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 30,
		"descKo": "무인점포에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-flower",
		"groupId": "daily",
		"nameKo": "꽃집",
		"slug": "daily-flower",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 31,
		"descKo": "꽃집에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "daily-liquor",
		"groupId": "daily",
		"nameKo": "주류",
		"slug": "daily-liquor",
		"symbolId": "bottle",
		"sensitive": false,
		"sortOrder": 32,
		"descKo": "주류에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-fashion",
		"groupId": "shop",
		"nameKo": "의류",
		"slug": "shop-fashion",
		"symbolId": "shirt",
		"sensitive": false,
		"sortOrder": 33,
		"descKo": "의류에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-shoes",
		"groupId": "shop",
		"nameKo": "신발",
		"slug": "shop-shoes",
		"symbolId": "shoe",
		"sensitive": false,
		"sortOrder": 34,
		"descKo": "신발에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-bag",
		"groupId": "shop",
		"nameKo": "가방·잡화",
		"slug": "shop-bag",
		"symbolId": "bag",
		"sensitive": false,
		"sortOrder": 35,
		"descKo": "가방·잡화에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-jewelry",
		"groupId": "shop",
		"nameKo": "주얼리·시계",
		"slug": "shop-jewelry",
		"symbolId": "gem",
		"sensitive": false,
		"sortOrder": 36,
		"descKo": "주얼리·시계에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-sportswear",
		"groupId": "shop",
		"nameKo": "스포츠웨어",
		"slug": "shop-sportswear",
		"symbolId": "shirt",
		"sensitive": false,
		"sortOrder": 37,
		"descKo": "스포츠웨어에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-outdoor",
		"groupId": "shop",
		"nameKo": "아웃도어",
		"slug": "shop-outdoor",
		"symbolId": "shirt",
		"sensitive": false,
		"sortOrder": 38,
		"descKo": "아웃도어에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-kids",
		"groupId": "shop",
		"nameKo": "유아·아동",
		"slug": "shop-kids",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 39,
		"descKo": "유아·아동에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-underwear",
		"groupId": "shop",
		"nameKo": "언더웨어",
		"slug": "shop-underwear",
		"symbolId": "shirt",
		"sensitive": false,
		"sortOrder": 40,
		"descKo": "언더웨어에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-secondhand",
		"groupId": "shop",
		"nameKo": "중고·빈티지",
		"slug": "shop-secondhand",
		"symbolId": "bag",
		"sensitive": false,
		"sortOrder": 41,
		"descKo": "중고·빈티지에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-department",
		"groupId": "shop",
		"nameKo": "백화점",
		"slug": "shop-department",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 42,
		"descKo": "백화점에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-outlet",
		"groupId": "shop",
		"nameKo": "아울렛",
		"slug": "shop-outlet",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 43,
		"descKo": "아울렛에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-online",
		"groupId": "shop",
		"nameKo": "온라인쇼핑",
		"slug": "shop-online",
		"symbolId": "cart",
		"sensitive": false,
		"sortOrder": 44,
		"descKo": "온라인쇼핑에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-electronics",
		"groupId": "shop",
		"nameKo": "가전·디지털",
		"slug": "shop-electronics",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 45,
		"descKo": "가전·디지털에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-mobile",
		"groupId": "shop",
		"nameKo": "통신·휴대폰",
		"slug": "shop-mobile",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 46,
		"descKo": "통신·휴대폰에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-furniture",
		"groupId": "shop",
		"nameKo": "가구",
		"slug": "shop-furniture",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 47,
		"descKo": "가구에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "shop-interior",
		"groupId": "shop",
		"nameKo": "인테리어 소품",
		"slug": "shop-interior",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 48,
		"descKo": "인테리어 소품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-hair",
		"groupId": "beauty",
		"nameKo": "미용실",
		"slug": "beauty-hair",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 49,
		"descKo": "미용실에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-nail",
		"groupId": "beauty",
		"nameKo": "네일",
		"slug": "beauty-nail",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 50,
		"descKo": "네일에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-skin",
		"groupId": "beauty",
		"nameKo": "피부관리",
		"slug": "beauty-skin",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 51,
		"descKo": "피부관리에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-cosmetics",
		"groupId": "beauty",
		"nameKo": "화장품",
		"slug": "beauty-cosmetics",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 52,
		"descKo": "화장품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-perfume",
		"groupId": "beauty",
		"nameKo": "향수",
		"slug": "beauty-perfume",
		"symbolId": "bottle",
		"sensitive": false,
		"sortOrder": 53,
		"descKo": "향수에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-barber",
		"groupId": "beauty",
		"nameKo": "이발소",
		"slug": "beauty-barber",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 54,
		"descKo": "이발소에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-spa",
		"groupId": "beauty",
		"nameKo": "스파·사우나",
		"slug": "beauty-spa",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 55,
		"descKo": "스파·사우나에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-massage",
		"groupId": "beauty",
		"nameKo": "마사지",
		"slug": "beauty-massage",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 56,
		"descKo": "마사지에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-lash",
		"groupId": "beauty",
		"nameKo": "속눈썹·왁싱",
		"slug": "beauty-lash",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 57,
		"descKo": "속눈썹·왁싱에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "beauty-semipermanent",
		"groupId": "beauty",
		"nameKo": "반영구·타투",
		"slug": "beauty-semipermanent",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 58,
		"descKo": "반영구·타투에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "health-pharmacy",
		"groupId": "health",
		"nameKo": "약국",
		"slug": "health-pharmacy",
		"symbolId": "pill",
		"sensitive": true,
		"sortOrder": 59,
		"descKo": "약국 기록은 업종과 총액만 안전하게 남겨요. 품목과 메모는 저장하지 않아요."
	},
	{
		"categoryId": "health-clinic",
		"groupId": "health",
		"nameKo": "병의원",
		"slug": "health-clinic",
		"symbolId": "stethoscope",
		"sensitive": true,
		"sortOrder": 60,
		"descKo": "병의원 기록은 업종과 총액만 안전하게 남겨요. 품목과 메모는 저장하지 않아요."
	},
	{
		"categoryId": "health-dental",
		"groupId": "health",
		"nameKo": "치과",
		"slug": "health-dental",
		"symbolId": "stethoscope",
		"sensitive": true,
		"sortOrder": 61,
		"descKo": "치과 기록은 업종과 총액만 안전하게 남겨요. 품목과 메모는 저장하지 않아요."
	},
	{
		"categoryId": "health-oriental",
		"groupId": "health",
		"nameKo": "한의원",
		"slug": "health-oriental",
		"symbolId": "stethoscope",
		"sensitive": true,
		"sortOrder": 62,
		"descKo": "한의원 기록은 업종과 총액만 안전하게 남겨요. 품목과 메모는 저장하지 않아요."
	},
	{
		"categoryId": "health-checkup",
		"groupId": "health",
		"nameKo": "건강검진",
		"slug": "health-checkup",
		"symbolId": "stethoscope",
		"sensitive": true,
		"sortOrder": 63,
		"descKo": "건강검진 기록은 업종과 총액만 안전하게 남겨요. 품목과 메모는 저장하지 않아요."
	},
	{
		"categoryId": "health-optical",
		"groupId": "health",
		"nameKo": "안경·렌즈",
		"slug": "health-optical",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 64,
		"descKo": "안경·렌즈에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "health-supplement",
		"groupId": "health",
		"nameKo": "건강식품",
		"slug": "health-supplement",
		"symbolId": "bottle",
		"sensitive": false,
		"sortOrder": 65,
		"descKo": "건강식품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "health-gym",
		"groupId": "health",
		"nameKo": "헬스·피트니스",
		"slug": "health-gym",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 66,
		"descKo": "헬스·피트니스에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-subway",
		"groupId": "transport",
		"nameKo": "지하철",
		"slug": "transport-subway",
		"symbolId": "train",
		"sensitive": false,
		"sortOrder": 67,
		"descKo": "지하철에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-bus",
		"groupId": "transport",
		"nameKo": "버스",
		"slug": "transport-bus",
		"symbolId": "train",
		"sensitive": false,
		"sortOrder": 68,
		"descKo": "버스에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-taxi",
		"groupId": "transport",
		"nameKo": "택시",
		"slug": "transport-taxi",
		"symbolId": "car",
		"sensitive": false,
		"sortOrder": 69,
		"descKo": "택시에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-train",
		"groupId": "transport",
		"nameKo": "기차",
		"slug": "transport-train",
		"symbolId": "train",
		"sensitive": false,
		"sortOrder": 70,
		"descKo": "기차에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-express",
		"groupId": "transport",
		"nameKo": "고속·시외버스",
		"slug": "transport-express",
		"symbolId": "train",
		"sensitive": false,
		"sortOrder": 71,
		"descKo": "고속·시외버스에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-air",
		"groupId": "transport",
		"nameKo": "항공",
		"slug": "transport-air",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 72,
		"descKo": "항공에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-fuel",
		"groupId": "transport",
		"nameKo": "주유",
		"slug": "transport-fuel",
		"symbolId": "fuel",
		"sensitive": false,
		"sortOrder": 73,
		"descKo": "주유에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-parking",
		"groupId": "transport",
		"nameKo": "주차",
		"slug": "transport-parking",
		"symbolId": "car",
		"sensitive": false,
		"sortOrder": 74,
		"descKo": "주차에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-toll",
		"groupId": "transport",
		"nameKo": "통행료",
		"slug": "transport-toll",
		"symbolId": "car",
		"sensitive": false,
		"sortOrder": 75,
		"descKo": "통행료에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "transport-carshare",
		"groupId": "transport",
		"nameKo": "카셰어링·렌터카",
		"slug": "transport-carshare",
		"symbolId": "car",
		"sensitive": false,
		"sortOrder": 76,
		"descKo": "카셰어링·렌터카에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-book",
		"groupId": "culture",
		"nameKo": "서점",
		"slug": "culture-book",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 77,
		"descKo": "서점에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-movie",
		"groupId": "culture",
		"nameKo": "영화관",
		"slug": "culture-movie",
		"symbolId": "film",
		"sensitive": false,
		"sortOrder": 78,
		"descKo": "영화관에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-performance",
		"groupId": "culture",
		"nameKo": "공연·연극",
		"slug": "culture-performance",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 79,
		"descKo": "공연·연극에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-concert",
		"groupId": "culture",
		"nameKo": "콘서트",
		"slug": "culture-concert",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 80,
		"descKo": "콘서트에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-exhibition",
		"groupId": "culture",
		"nameKo": "전시·박물관",
		"slug": "culture-exhibition",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 81,
		"descKo": "전시·박물관에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-sports",
		"groupId": "culture",
		"nameKo": "스포츠 관람",
		"slug": "culture-sports",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 82,
		"descKo": "스포츠 관람에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-studycafe",
		"groupId": "culture",
		"nameKo": "스터디카페",
		"slug": "culture-studycafe",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 83,
		"descKo": "스터디카페에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-karaoke",
		"groupId": "culture",
		"nameKo": "노래방",
		"slug": "culture-karaoke",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 84,
		"descKo": "노래방에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-pcroom",
		"groupId": "culture",
		"nameKo": "PC방",
		"slug": "culture-pcroom",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 85,
		"descKo": "PC방에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-board",
		"groupId": "culture",
		"nameKo": "보드게임·방탈출",
		"slug": "culture-board",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 86,
		"descKo": "보드게임·방탈출에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-hobby",
		"groupId": "culture",
		"nameKo": "취미·공방",
		"slug": "culture-hobby",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 87,
		"descKo": "취미·공방에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-music",
		"groupId": "culture",
		"nameKo": "악기·음반",
		"slug": "culture-music",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 88,
		"descKo": "악기·음반에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-subscription",
		"groupId": "culture",
		"nameKo": "구독 서비스",
		"slug": "culture-subscription",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 89,
		"descKo": "구독 서비스에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "culture-game",
		"groupId": "culture",
		"nameKo": "게임·앱 결제",
		"slug": "culture-game",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 90,
		"descKo": "게임·앱 결제에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-academy",
		"groupId": "edu",
		"nameKo": "학원",
		"slug": "edu-academy",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 91,
		"descKo": "학원에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-tutoring",
		"groupId": "edu",
		"nameKo": "과외",
		"slug": "edu-tutoring",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 92,
		"descKo": "과외에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-online",
		"groupId": "edu",
		"nameKo": "온라인 강의",
		"slug": "edu-online",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 93,
		"descKo": "온라인 강의에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-language",
		"groupId": "edu",
		"nameKo": "어학",
		"slug": "edu-language",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 94,
		"descKo": "어학에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-exam",
		"groupId": "edu",
		"nameKo": "시험 응시료",
		"slug": "edu-exam",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 95,
		"descKo": "시험 응시료에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-textbook",
		"groupId": "edu",
		"nameKo": "교재",
		"slug": "edu-textbook",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 96,
		"descKo": "교재에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-license",
		"groupId": "edu",
		"nameKo": "자격증",
		"slug": "edu-license",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 97,
		"descKo": "자격증에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "edu-workshop",
		"groupId": "edu",
		"nameKo": "워크숍·세미나",
		"slug": "edu-workshop",
		"symbolId": "book",
		"sensitive": false,
		"sortOrder": 98,
		"descKo": "워크숍·세미나에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-rent",
		"groupId": "home",
		"nameKo": "월세·관리비",
		"slug": "home-rent",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 99,
		"descKo": "월세·관리비에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-utility",
		"groupId": "home",
		"nameKo": "공과금",
		"slug": "home-utility",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 100,
		"descKo": "공과금에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-telecom",
		"groupId": "home",
		"nameKo": "통신요금",
		"slug": "home-telecom",
		"symbolId": "sparkle",
		"sensitive": false,
		"sortOrder": 101,
		"descKo": "통신요금에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-insurance",
		"groupId": "home",
		"nameKo": "보험료",
		"slug": "home-insurance",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 102,
		"descKo": "보험료 지출을 기록하는 칸이에요. 상품 추천이나 비교 없이 지난 소비를 차분히 돌아봐요."
	},
	{
		"categoryId": "home-cleaning",
		"groupId": "home",
		"nameKo": "청소 서비스",
		"slug": "home-cleaning",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 103,
		"descKo": "청소 서비스에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-moving",
		"groupId": "home",
		"nameKo": "이사",
		"slug": "home-moving",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 104,
		"descKo": "이사에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-fix",
		"groupId": "home",
		"nameKo": "집수리",
		"slug": "home-fix",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 105,
		"descKo": "집수리에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-security",
		"groupId": "home",
		"nameKo": "보안·경비",
		"slug": "home-security",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 106,
		"descKo": "보안·경비에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-storage",
		"groupId": "home",
		"nameKo": "창고·보관",
		"slug": "home-storage",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 107,
		"descKo": "창고·보관에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "home-rental",
		"groupId": "home",
		"nameKo": "렌탈",
		"slug": "home-rental",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 108,
		"descKo": "렌탈에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-food",
		"groupId": "pet",
		"nameKo": "사료·간식",
		"slug": "pet-food",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 109,
		"descKo": "사료·간식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-supply",
		"groupId": "pet",
		"nameKo": "반려용품",
		"slug": "pet-supply",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 110,
		"descKo": "반려용품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-hospital",
		"groupId": "pet",
		"nameKo": "동물병원",
		"slug": "pet-hospital",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 111,
		"descKo": "동물병원에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-grooming",
		"groupId": "pet",
		"nameKo": "반려동물 미용",
		"slug": "pet-grooming",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 112,
		"descKo": "반려동물 미용에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-care",
		"groupId": "pet",
		"nameKo": "호텔·돌봄",
		"slug": "pet-care",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 113,
		"descKo": "호텔·돌봄에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "pet-insurance",
		"groupId": "pet",
		"nameKo": "펫보험",
		"slug": "pet-insurance",
		"symbolId": "paw",
		"sensitive": false,
		"sortOrder": 114,
		"descKo": "펫보험 지출을 기록하는 칸이에요. 상품 추천이나 비교 없이 지난 소비를 차분히 돌아봐요."
	},
	{
		"categoryId": "social-gift",
		"groupId": "social",
		"nameKo": "선물",
		"slug": "social-gift",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 115,
		"descKo": "선물에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "social-ceremony",
		"groupId": "social",
		"nameKo": "경조사",
		"slug": "social-ceremony",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 116,
		"descKo": "경조사에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "social-donation",
		"groupId": "social",
		"nameKo": "기부",
		"slug": "social-donation",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 117,
		"descKo": "기부에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "social-gathering",
		"groupId": "social",
		"nameKo": "모임·회식",
		"slug": "social-gathering",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 118,
		"descKo": "모임·회식에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "social-souvenir",
		"groupId": "social",
		"nameKo": "기념품",
		"slug": "social-souvenir",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 119,
		"descKo": "기념품에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "social-card",
		"groupId": "social",
		"nameKo": "카드·편지",
		"slug": "social-card",
		"symbolId": "gift",
		"sensitive": false,
		"sortOrder": 120,
		"descKo": "카드·편지에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-lodging",
		"groupId": "etc",
		"nameKo": "숙박",
		"slug": "etc-lodging",
		"symbolId": "home",
		"sensitive": false,
		"sortOrder": 121,
		"descKo": "숙박에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-tour",
		"groupId": "etc",
		"nameKo": "여행·투어",
		"slug": "etc-tour",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 122,
		"descKo": "여행·투어에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-dutyfree",
		"groupId": "etc",
		"nameKo": "면세점",
		"slug": "etc-dutyfree",
		"symbolId": "bag",
		"sensitive": false,
		"sortOrder": 123,
		"descKo": "면세점에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-exchange",
		"groupId": "etc",
		"nameKo": "환전",
		"slug": "etc-exchange",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 124,
		"descKo": "환전에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-fee",
		"groupId": "etc",
		"nameKo": "수수료",
		"slug": "etc-fee",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 125,
		"descKo": "수수료에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-recurring",
		"groupId": "etc",
		"nameKo": "기타 정기결제",
		"slug": "etc-recurring",
		"symbolId": "ticket",
		"sensitive": false,
		"sortOrder": 126,
		"descKo": "기타 정기결제에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-vending",
		"groupId": "etc",
		"nameKo": "자판기·무인기",
		"slug": "etc-vending",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 127,
		"descKo": "자판기·무인기에서 남긴 소비를 표본으로 모아요. 여러 번 기록할수록 도감의 모습이 또렷해져요."
	},
	{
		"categoryId": "etc-other",
		"groupId": "etc",
		"nameKo": "기타",
		"slug": "etc-other",
		"symbolId": "store",
		"sensitive": false,
		"sortOrder": 128,
		"descKo": "아직 분류하지 않은 소비를 잠시 모아 두는 칸이에요. 나중에 직접 분류를 정하면 도감에 반영돼요."
	}
]
